// Factory for fontSize
export function createBorderRadius() {
    return {
        normal : {
            mobile : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            },

            tablet : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            },

            desktop : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            }
        },
        hover : {
            mobile : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            },

            tablet : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            },

            desktop : {
                style: [],
                topLeft: '',
                topLeftUnit: 'px',
                topRight: '',
                topRightUnit: 'px',
                bottomLeft: '',
                bottomLeftUnit: 'px',
                bottomRight: '',
                bottomRightUnit: 'px'
            }
        }
    }
}

export function createHeight() {
    return {
        mobile: {
            height: '',
            heightUnit: 'px',
            minHeight: '',
            minHeightUnit: 'px',
            maxHeight: '',
            maxHeightUnit: 'px'
        },
        tablet: {
            height: '',
            heightUnit: 'px',
            minHeight: '',
            minHeightUnit: 'px',
            maxHeight: '',
            maxHeightUnit: 'px'
        },
        desktop: {
            height: '',
            heightUnit: 'px',
            minHeight: '',
            minHeightUnit: 'px',
            maxHeight: '',
            maxHeightUnit: 'px'
        }
    };
}
export function createWidth() {
    return {
        mobile: {
            width: '',
            widthUnit: '%',
            minWidth: '',
            minWidthUnit: '%',
            maxWidth: '',
            maxWidthUnit: '%'
        },
        tablet: {
            width: '',
            widthUnit: '%',
            minWidth: '',
            minWidthUnit: '%',
            maxWidth: '',
            maxWidthUnit: '%'
        },
        desktop: {
            width: '',
            widthUnit: '%',
            minWidth: '',
            minWidthUnit: '%',
            maxWidth: '',
            maxWidthUnit: '%'
        }
    };
}
export function createHoverTransition() {
    return {
        normal: {
            transition: '',
            transitionUnit: 'ms'
        },
        hover: {
            transition: '',
            transitionUnit: 'ms'
        }
    };
}
export function createShadow() {
    return {
        normal: {
            mobile: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            },
            tablet: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            },
            desktop: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            }
        },
        hover: {
            mobile: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            },
            tablet: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            },
            desktop: {
                style: '',
                shadowType: 'none',
                offsetX: 0,
                offsetY: 0,
                blurRadius: 10,
                spreadRadius: 0,
                shadowColor: null,
                opacity: 100,
                inset: false
            }
        }
    };
}
export function createTransform() {
    return {
        normal: {
            mobile: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            },
            tablet: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            },
            desktop: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            }
        },
        hover: {
            mobile: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            },
            tablet: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            },
            desktop: {
                rotate: 0,
                rotateX: 0,
                rotateY: 0,
                scale: 1,
                translateX: 0,
                translateY: 0,
                skewX: 0,
                skewY: 0
            }
        }
    };
}
export function createFilters() {
    return {
        normal: {
            mobile: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            },
            tablet: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            },
            desktop: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            }
        },
        hover: {
            mobile: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            },
            tablet: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            },
            desktop: {
                blur: 0,
                brightness: 100,
                grayscale: 0,
                contrast: 100,
                saturate: 100,
                hueRotate: 0,
                sepia: 0,
                invert: 0
            }
        }
    };
}
export function createBorders() {
    return {
        normal: {
            color: '',
            borderStyle: 'none',
            selectedPosition: '',
            borderWidth: '',
            borderWidthUnit: 'px'
        },
        hover: {
            color: '',
            borderStyle: 'none',
            selectedPosition: '',
            borderWidth: '',
            borderWidthUnit: 'px'
        }
    };
}
export function mergeFontSize(defaultFontSize, dbFontSize = {}) {
    return {
        desktop: dbFontSize?.desktop ?? defaultFontSize.desktop,
        tablet: dbFontSize?.tablet ?? defaultFontSize.tablet,
        mobile: dbFontSize?.mobile ?? defaultFontSize.mobile
    };
}

export function mergeGridAlignments(defaultAlignments, dbAlignments) {
    // Ensure dbAlignments has the expected structure, or fallback to an empty object
    dbAlignments = dbAlignments || {};

    return {
        mobile: {
            horizontal: dbAlignments.mobile?.horizontal ?? defaultAlignments.mobile.horizontal,
            vertical: dbAlignments.mobile?.vertical ?? defaultAlignments.mobile.vertical
        },
        tablet: {
            horizontal: dbAlignments.tablet?.horizontal ?? defaultAlignments.tablet.horizontal,
            vertical: dbAlignments.tablet?.vertical ?? defaultAlignments.tablet.vertical
        },
        desktop: {
            horizontal: dbAlignments.desktop?.horizontal ?? defaultAlignments.desktop.horizontal,
            vertical: dbAlignments.desktop?.vertical ?? defaultAlignments.desktop.vertical
        }
    };
}

export function mergeOrder(defaultOrder, dbOrder) {
    dbOrder = dbOrder || {};

    return {
        desktop: {
            order: dbOrder.desktop?.order ?? defaultOrder.desktop.order
        },
        tablet: {
            order: dbOrder.tablet?.order ?? defaultOrder.tablet.order
        },
        mobile: {
            order: dbOrder.mobile?.order ?? defaultOrder.mobile.order
        }
    }
}
export function mergeHeight(defaultHeight, dbHeight) {
    // Ensure dbHeight has the expected structure, or fallback to an empty object
    dbHeight = dbHeight || {};

    return {
        mobile: {
            height: dbHeight.mobile?.height ?? defaultHeight.mobile.height,
            heightUnit: dbHeight.mobile?.heightUnit ?? defaultHeight.mobile.heightUnit,
            minHeight: dbHeight.mobile?.minHeight ?? defaultHeight.mobile.minHeight,
            minHeightUnit: dbHeight.mobile?.minHeightUnit ?? defaultHeight.mobile.minHeightUnit,
            maxHeight: dbHeight.mobile?.maxHeight ?? defaultHeight.mobile.maxHeight,
            maxHeightUnit: dbHeight.mobile?.maxHeightUnit ?? defaultHeight.mobile.maxHeightUnit
        },
        tablet: {
            height: dbHeight.tablet?.height ?? defaultHeight.tablet.height,
            heightUnit: dbHeight.tablet?.heightUnit ?? defaultHeight.tablet.heightUnit,
            minHeight: dbHeight.tablet?.minHeight ?? defaultHeight.tablet.minHeight,
            minHeightUnit: dbHeight.tablet?.minHeightUnit ?? defaultHeight.tablet.minHeightUnit,
            maxHeight: dbHeight.tablet?.maxHeight ?? defaultHeight.tablet.maxHeight,
            maxHeightUnit: dbHeight.tablet?.maxHeightUnit ?? defaultHeight.tablet.maxHeightUnit
        },
        desktop: {
            height: dbHeight.desktop?.height ?? defaultHeight.desktop.height,
            heightUnit: dbHeight.desktop?.heightUnit ?? defaultHeight.desktop.heightUnit,
            minHeight: dbHeight.desktop?.minHeight ?? defaultHeight.desktop.minHeight,
            minHeightUnit: dbHeight.desktop?.minHeightUnit ?? defaultHeight.desktop.minHeightUnit,
            maxHeight: dbHeight.desktop?.maxHeight ?? defaultHeight.desktop.maxHeight,
            maxHeightUnit: dbHeight.desktop?.maxHeightUnit ?? defaultHeight.desktop.maxHeightUnit
        }
    };
}

export function mergeWidth(defaultWidth, dbWidth) {
    // Ensure dbWidth has the expected structure, or fallback to an empty object
    dbWidth = dbWidth || {};

    return {
        mobile: {
            width: dbWidth.mobile?.width ?? defaultWidth.mobile.width,
            widthUnit: dbWidth.mobile?.widthUnit ?? defaultWidth.mobile.widthUnit,
            minWidth: dbWidth.mobile?.minWidth ?? defaultWidth.mobile.minWidth,
            minWidthUnit: dbWidth.mobile?.minWidthUnit ?? defaultWidth.mobile.minWidthUnit,
            maxWidth: dbWidth.mobile?.maxWidth ?? defaultWidth.mobile.maxWidth,
            maxWidthUnit: dbWidth.mobile?.maxWidthUnit ?? defaultWidth.mobile.maxWidthUnit
        },
        tablet: {
            width: dbWidth.tablet?.width ?? defaultWidth.tablet.width,
            widthUnit: dbWidth.tablet?.widthUnit ?? defaultWidth.tablet.widthUnit,
            minWidth: dbWidth.tablet?.minWidth ?? defaultWidth.tablet.minWidth,
            minWidthUnit: dbWidth.tablet?.minWidthUnit ?? defaultWidth.tablet.minWidthUnit,
            maxWidth: dbWidth.tablet?.maxWidth ?? defaultWidth.tablet.maxWidth,
            maxWidthUnit: dbWidth.tablet?.maxWidthUnit ?? defaultWidth.tablet.maxWidthUnit
        },
        desktop: {
            width: dbWidth.desktop?.width ?? defaultWidth.desktop.width,
            widthUnit: dbWidth.desktop?.widthUnit ?? defaultWidth.desktop.widthUnit,
            minWidth: dbWidth.desktop?.minWidth ?? defaultWidth.desktop.minWidth,
            minWidthUnit: dbWidth.desktop?.minWidthUnit ?? defaultWidth.desktop.minWidthUnit,
            maxWidth: dbWidth.desktop?.maxWidth ?? defaultWidth.desktop.maxWidth,
            maxWidthUnit: dbWidth.desktop?.maxWidthUnit ?? defaultWidth.desktop.maxWidthUnit
        }
    };
}

export function mergeHoverTransition(defaultTransition, dbTransition) {
    // Ensure dbTransition has the expected structure, or fallback to an empty object
    dbTransition = dbTransition || {};

    return {
        normal: {
            transition: dbTransition.normal?.transition ?? defaultTransition.normal.transition,
            transitionUnit: dbTransition.normal?.transitionUnit ?? defaultTransition.normal.transitionUnit
        },
        hover: {
            transition: dbTransition.hover?.transition ?? defaultTransition.hover.transition,
            transitionUnit: dbTransition.hover?.transitionUnit ?? defaultTransition.hover.transitionUnit
        }
    };
}


export function mergeFonts(defaultFonts, dbFonts) {
    // Ensure dbFonts has the expected structure, or fallback to an empty object
    dbFonts = dbFonts || {};

    return {
        weight: dbFonts.weight ?? defaultFonts.weight,
        family: dbFonts.family ?? defaultFonts.family
    };
}


export function mergeShadows(defaultShadows, dbShadows) {
    // Ensure dbShadows has the expected structure, or fallback to an empty object
    dbShadows = dbShadows || {};

    return {
        normal: {
            mobile: {
                style: dbShadows.normal?.mobile?.style ?? defaultShadows.normal.mobile.style,
                shadowType: dbShadows.normal?.mobile?.shadowType ?? defaultShadows.normal.mobile.shadowType,
                offsetX: dbShadows.normal?.mobile?.offsetX ?? defaultShadows.normal.mobile.offsetX,
                offsetY: dbShadows.normal?.mobile?.offsetY ?? defaultShadows.normal.mobile.offsetY,
                blurRadius: dbShadows.normal?.mobile?.blurRadius ?? defaultShadows.normal.mobile.blurRadius,
                spreadRadius: dbShadows.normal?.mobile?.spreadRadius ?? defaultShadows.normal.mobile.spreadRadius,
                shadowColor: dbShadows.normal?.mobile?.shadowColor ?? defaultShadows.normal.mobile.shadowColor,
                opacity: dbShadows.normal?.mobile?.opacity ?? defaultShadows.normal.mobile.opacity,
                inset: dbShadows.normal?.mobile?.inset ?? defaultShadows.normal.mobile.inset
            },
            tablet: {
                style: dbShadows.normal?.tablet?.style ?? defaultShadows.normal.tablet.style,
                shadowType: dbShadows.normal?.tablet?.shadowType ?? defaultShadows.normal.tablet.shadowType,
                offsetX: dbShadows.normal?.tablet?.offsetX ?? defaultShadows.normal.tablet.offsetX,
                offsetY: dbShadows.normal?.tablet?.offsetY ?? defaultShadows.normal.tablet.offsetY,
                blurRadius: dbShadows.normal?.tablet?.blurRadius ?? defaultShadows.normal.tablet.blurRadius,
                spreadRadius: dbShadows.normal?.tablet?.spreadRadius ?? defaultShadows.normal.tablet.spreadRadius,
                shadowColor: dbShadows.normal?.tablet?.shadowColor ?? defaultShadows.normal.tablet.shadowColor,
                opacity: dbShadows.normal?.tablet?.opacity ?? defaultShadows.normal.tablet.opacity,
                inset: dbShadows.normal?.tablet?.inset ?? defaultShadows.normal.tablet.inset
            },
            desktop: {
                style: dbShadows.normal?.desktop?.style ?? defaultShadows.normal.desktop.style,
                shadowType: dbShadows.normal?.desktop?.shadowType ?? defaultShadows.normal.desktop.shadowType,
                offsetX: dbShadows.normal?.desktop?.offsetX ?? defaultShadows.normal.desktop.offsetX,
                offsetY: dbShadows.normal?.desktop?.offsetY ?? defaultShadows.normal.desktop.offsetY,
                blurRadius: dbShadows.normal?.desktop?.blurRadius ?? defaultShadows.normal.desktop.blurRadius,
                spreadRadius: dbShadows.normal?.desktop?.spreadRadius ?? defaultShadows.normal.desktop.spreadRadius,
                shadowColor: dbShadows.normal?.desktop?.shadowColor ?? defaultShadows.normal.desktop.shadowColor,
                opacity: dbShadows.normal?.desktop?.opacity ?? defaultShadows.normal.desktop.opacity,
                inset: dbShadows.normal?.desktop?.inset ?? defaultShadows.normal.desktop.inset
            }
        },
        hover: {
            mobile: {
                style: dbShadows.hover?.mobile?.style ?? defaultShadows.hover.mobile.style,
                shadowType: dbShadows.hover?.mobile?.shadowType ?? defaultShadows.hover.mobile.shadowType,
                offsetX: dbShadows.hover?.mobile?.offsetX ?? defaultShadows.hover.mobile.offsetX,
                offsetY: dbShadows.hover?.mobile?.offsetY ?? defaultShadows.hover.mobile.offsetY,
                blurRadius: dbShadows.hover?.mobile?.blurRadius ?? defaultShadows.hover.mobile.blurRadius,
                spreadRadius: dbShadows.hover?.mobile?.spreadRadius ?? defaultShadows.hover.mobile.spreadRadius,
                shadowColor: dbShadows.hover?.mobile?.shadowColor ?? defaultShadows.hover.mobile.shadowColor,
                opacity: dbShadows.hover?.mobile?.opacity ?? defaultShadows.hover.mobile.opacity,
                inset: dbShadows.hover?.mobile?.inset ?? defaultShadows.hover.mobile.inset
            },
            tablet: {
                style: dbShadows.hover?.tablet?.style ?? defaultShadows.hover.tablet.style,
                shadowType: dbShadows.hover?.tablet?.shadowType ?? defaultShadows.hover.tablet.shadowType,
                offsetX: dbShadows.hover?.tablet?.offsetX ?? defaultShadows.hover.tablet.offsetX,
                offsetY: dbShadows.hover?.tablet?.offsetY ?? defaultShadows.hover.tablet.offsetY,
                blurRadius: dbShadows.hover?.tablet?.blurRadius ?? defaultShadows.hover.tablet.blurRadius,
                spreadRadius: dbShadows.hover?.tablet?.spreadRadius ?? defaultShadows.hover.tablet.spreadRadius,
                shadowColor: dbShadows.hover?.tablet?.shadowColor ?? defaultShadows.hover.tablet.shadowColor,
                opacity: dbShadows.hover?.tablet?.opacity ?? defaultShadows.hover.tablet.opacity,
                inset: dbShadows.hover?.tablet?.inset ?? defaultShadows.hover.tablet.inset
            },
            desktop: {
                style: dbShadows.hover?.desktop?.style ?? defaultShadows.hover.desktop.style,
                shadowType: dbShadows.hover?.desktop?.shadowType ?? defaultShadows.hover.desktop.shadowType,
                offsetX: dbShadows.hover?.desktop?.offsetX ?? defaultShadows.hover.desktop.offsetX,
                offsetY: dbShadows.hover?.desktop?.offsetY ?? defaultShadows.hover.desktop.offsetY,
                blurRadius: dbShadows.hover?.desktop?.blurRadius ?? defaultShadows.hover.desktop.blurRadius,
                spreadRadius: dbShadows.hover?.desktop?.spreadRadius ?? defaultShadows.hover.desktop.spreadRadius,
                shadowColor: dbShadows.hover?.desktop?.shadowColor ?? defaultShadows.hover.desktop.shadowColor,
                opacity: dbShadows.hover?.desktop?.opacity ?? defaultShadows.hover.desktop.opacity,
                inset: dbShadows.hover?.desktop?.inset ?? defaultShadows.hover.desktop.inset
            }
        }
    };
}

export function mergeTransforms(defaultTransforms, dbTransforms) {
    // Ensure dbTransforms has the expected structure, or fallback to an empty object
    dbTransforms = dbTransforms || {};

    return {
        normal: {
            mobile: {
                rotate: dbTransforms.normal?.mobile?.rotate ?? defaultTransforms.normal.mobile.rotate,
                rotateX: dbTransforms.normal?.mobile?.rotateX ?? defaultTransforms.normal.mobile.rotateX,
                rotateY: dbTransforms.normal?.mobile?.rotateY ?? defaultTransforms.normal.mobile.rotateY,
                scale: dbTransforms.normal?.mobile?.scale ?? defaultTransforms.normal.mobile.scale,
                translateX: dbTransforms.normal?.mobile?.translateX ?? defaultTransforms.normal.mobile.translateX,
                translateY: dbTransforms.normal?.mobile?.translateY ?? defaultTransforms.normal.mobile.translateY,
                skewX: dbTransforms.normal?.mobile?.skewX ?? defaultTransforms.normal.mobile.skewX,
                skewY: dbTransforms.normal?.mobile?.skewY ?? defaultTransforms.normal.mobile.skewY
            },
            tablet: {
                rotate: dbTransforms.normal?.tablet?.rotate ?? defaultTransforms.normal.tablet.rotate,
                rotateX: dbTransforms.normal?.tablet?.rotateX ?? defaultTransforms.normal.tablet.rotateX,
                rotateY: dbTransforms.normal?.tablet?.rotateY ?? defaultTransforms.normal.tablet.rotateY,
                scale: dbTransforms.normal?.tablet?.scale ?? defaultTransforms.normal.tablet.scale,
                translateX: dbTransforms.normal?.tablet?.translateX ?? defaultTransforms.normal.tablet.translateX,
                translateY: dbTransforms.normal?.tablet?.translateY ?? defaultTransforms.normal.tablet.translateY,
                skewX: dbTransforms.normal?.tablet?.skewX ?? defaultTransforms.normal.tablet.skewX,
                skewY: dbTransforms.normal?.tablet?.skewY ?? defaultTransforms.normal.tablet.skewY
            },
            desktop: {
                rotate: dbTransforms.normal?.desktop?.rotate ?? defaultTransforms.normal.desktop.rotate,
                rotateX: dbTransforms.normal?.desktop?.rotateX ?? defaultTransforms.normal.desktop.rotateX,
                rotateY: dbTransforms.normal?.desktop?.rotateY ?? defaultTransforms.normal.desktop.rotateY,
                scale: dbTransforms.normal?.desktop?.scale ?? defaultTransforms.normal.desktop.scale,
                translateX: dbTransforms.normal?.desktop?.translateX ?? defaultTransforms.normal.desktop.translateX,
                translateY: dbTransforms.normal?.desktop?.translateY ?? defaultTransforms.normal.desktop.translateY,
                skewX: dbTransforms.normal?.desktop?.skewX ?? defaultTransforms.normal.desktop.skewX,
                skewY: dbTransforms.normal?.desktop?.skewY ?? defaultTransforms.normal.desktop.skewY
            }
        },
        hover: {
            mobile: {
                rotate: dbTransforms.hover?.mobile?.rotate ?? defaultTransforms.hover.mobile.rotate,
                rotateX: dbTransforms.hover?.mobile?.rotateX ?? defaultTransforms.hover.mobile.rotateX,
                rotateY: dbTransforms.hover?.mobile?.rotateY ?? defaultTransforms.hover.mobile.rotateY,
                scale: dbTransforms.hover?.mobile?.scale ?? defaultTransforms.hover.mobile.scale,
                translateX: dbTransforms.hover?.mobile?.translateX ?? defaultTransforms.hover.mobile.translateX,
                translateY: dbTransforms.hover?.mobile?.translateY ?? defaultTransforms.hover.mobile.translateY,
                skewX: dbTransforms.hover?.mobile?.skewX ?? defaultTransforms.hover.mobile.skewX,
                skewY: dbTransforms.hover?.mobile?.skewY ?? defaultTransforms.hover.mobile.skewY
            },
            tablet: {
                rotate: dbTransforms.hover?.tablet?.rotate ?? defaultTransforms.hover.tablet.rotate,
                rotateX: dbTransforms.hover?.tablet?.rotateX ?? defaultTransforms.hover.tablet.rotateX,
                rotateY: dbTransforms.hover?.tablet?.rotateY ?? defaultTransforms.hover.tablet.rotateY,
                scale: dbTransforms.hover?.tablet?.scale ?? defaultTransforms.hover.tablet.scale,
                translateX: dbTransforms.hover?.tablet?.translateX ?? defaultTransforms.hover.tablet.translateX,
                translateY: dbTransforms.hover?.tablet?.translateY ?? defaultTransforms.hover.tablet.translateY,
                skewX: dbTransforms.hover?.tablet?.skewX ?? defaultTransforms.hover.tablet.skewX,
                skewY: dbTransforms.hover?.tablet?.skewY ?? defaultTransforms.hover.tablet.skewY
            },
            desktop: {
                rotate: dbTransforms.hover?.desktop?.rotate ?? defaultTransforms.hover.desktop.rotate,
                rotateX: dbTransforms.hover?.desktop?.rotateX ?? defaultTransforms.hover.desktop.rotateX,
                rotateY: dbTransforms.hover?.desktop?.rotateY ?? defaultTransforms.hover.desktop.rotateY,
                scale: dbTransforms.hover?.desktop?.scale ?? defaultTransforms.hover.desktop.scale,
                translateX: dbTransforms.hover?.desktop?.translateX ?? defaultTransforms.hover.desktop.translateX,
                translateY: dbTransforms.hover?.desktop?.translateY ?? defaultTransforms.hover.desktop.translateY,
                skewX: dbTransforms.hover?.desktop?.skewX ?? defaultTransforms.hover.desktop.skewX,
                skewY: dbTransforms.hover?.desktop?.skewY ?? defaultTransforms.hover.desktop.skewY
            }
        }
    };
}

export function mergeFilters(defaultFilters, dbFilters) {
    // Make sure dbFilters has the expected structure, or fallback to an empty object if not
    dbFilters = dbFilters || {};

    return {
        normal: {
            mobile: {
                blur: dbFilters.normal?.mobile?.blur ?? defaultFilters.normal.mobile.blur,
                brightness: dbFilters.normal?.mobile?.brightness ?? defaultFilters.normal.mobile.brightness,
                grayscale: dbFilters.normal?.mobile?.grayscale ?? defaultFilters.normal.mobile.grayscale,
                contrast: dbFilters.normal?.mobile?.contrast ?? defaultFilters.normal.mobile.contrast,
                saturate: dbFilters.normal?.mobile?.saturate ?? defaultFilters.normal.mobile.saturate,
                hueRotate: dbFilters.normal?.mobile?.hueRotate ?? defaultFilters.normal.mobile.hueRotate,
                sepia: dbFilters.normal?.mobile?.sepia ?? defaultFilters.normal.mobile.sepia,
                invert: dbFilters.normal?.mobile?.invert ?? defaultFilters.normal.mobile.invert
            },
            tablet: {
                blur: dbFilters.normal?.tablet?.blur ?? defaultFilters.normal.tablet.blur,
                brightness: dbFilters.normal?.tablet?.brightness ?? defaultFilters.normal.tablet.brightness,
                grayscale: dbFilters.normal?.tablet?.grayscale ?? defaultFilters.normal.tablet.grayscale,
                contrast: dbFilters.normal?.tablet?.contrast ?? defaultFilters.normal.tablet.contrast,
                saturate: dbFilters.normal?.tablet?.saturate ?? defaultFilters.normal.tablet.saturate,
                hueRotate: dbFilters.normal?.tablet?.hueRotate ?? defaultFilters.normal.tablet.hueRotate,
                sepia: dbFilters.normal?.tablet?.sepia ?? defaultFilters.normal.tablet.sepia,
                invert: dbFilters.normal?.tablet?.invert ?? defaultFilters.normal.tablet.invert
            },
            desktop: {
                blur: dbFilters.normal?.desktop?.blur ?? defaultFilters.normal.desktop.blur,
                brightness: dbFilters.normal?.desktop?.brightness ?? defaultFilters.normal.desktop.brightness,
                grayscale: dbFilters.normal?.desktop?.grayscale ?? defaultFilters.normal.desktop.grayscale,
                contrast: dbFilters.normal?.desktop?.contrast ?? defaultFilters.normal.desktop.contrast,
                saturate: dbFilters.normal?.desktop?.saturate ?? defaultFilters.normal.desktop.saturate,
                hueRotate: dbFilters.normal?.desktop?.hueRotate ?? defaultFilters.normal.desktop.hueRotate,
                sepia: dbFilters.normal?.desktop?.sepia ?? defaultFilters.normal.desktop.sepia,
                invert: dbFilters.normal?.desktop?.invert ?? defaultFilters.normal.desktop.invert
            }
        },
        hover: {
            mobile: {
                blur: dbFilters.hover?.mobile?.blur ?? defaultFilters.hover.mobile.blur,
                brightness: dbFilters.hover?.mobile?.brightness ?? defaultFilters.hover.mobile.brightness,
                grayscale: dbFilters.hover?.mobile?.grayscale ?? defaultFilters.hover.mobile.grayscale,
                contrast: dbFilters.hover?.mobile?.contrast ?? defaultFilters.hover.mobile.contrast,
                saturate: dbFilters.hover?.mobile?.saturate ?? defaultFilters.hover.mobile.saturate,
                hueRotate: dbFilters.hover?.mobile?.hueRotate ?? defaultFilters.hover.mobile.hueRotate,
                sepia: dbFilters.hover?.mobile?.sepia ?? defaultFilters.hover.mobile.sepia,
                invert: dbFilters.hover?.mobile?.invert ?? defaultFilters.hover.mobile.invert
            },
            tablet: {
                blur: dbFilters.hover?.tablet?.blur ?? defaultFilters.hover.tablet.blur,
                brightness: dbFilters.hover?.tablet?.brightness ?? defaultFilters.hover.tablet.brightness,
                grayscale: dbFilters.hover?.tablet?.grayscale ?? defaultFilters.hover.tablet.grayscale,
                contrast: dbFilters.hover?.tablet?.contrast ?? defaultFilters.hover.tablet.contrast,
                saturate: dbFilters.hover?.tablet?.saturate ?? defaultFilters.hover.tablet.saturate,
                hueRotate: dbFilters.hover?.tablet?.hueRotate ?? defaultFilters.hover.tablet.hueRotate,
                sepia: dbFilters.hover?.tablet?.sepia ?? defaultFilters.hover.tablet.sepia,
                invert: dbFilters.hover?.tablet?.invert ?? defaultFilters.hover.tablet.invert
            },
            desktop: {
                blur: dbFilters.hover?.desktop?.blur ?? defaultFilters.hover.desktop.blur,
                brightness: dbFilters.hover?.desktop?.brightness ?? defaultFilters.hover.desktop.brightness,
                grayscale: dbFilters.hover?.desktop?.grayscale ?? defaultFilters.hover.desktop.grayscale,
                contrast: dbFilters.hover?.desktop?.contrast ?? defaultFilters.hover.desktop.contrast,
                saturate: dbFilters.hover?.desktop?.saturate ?? defaultFilters.hover.desktop.saturate,
                hueRotate: dbFilters.hover?.desktop?.hueRotate ?? defaultFilters.hover.desktop.hueRotate,
                sepia: dbFilters.hover?.desktop?.sepia ?? defaultFilters.hover.desktop.sepia,
                invert: dbFilters.hover?.desktop?.invert ?? defaultFilters.hover.desktop.invert
            }
        }
    };
}

export function mergeBorder(defaultBorder, dbBorder) {
    // Ensure dbBorder is defined, fallback to empty object if not
    dbBorder = dbBorder || {};

    // If hover section is missing, initialize it with default values
    if (!dbBorder.normal) {
        dbBorder.normal = defaultBorder.normal;
    }
    if (!dbBorder.hover) {
        dbBorder.hover = defaultBorder.hover;
    }
    return {
        normal: {
            color: dbBorder.normal?.color !== '' ? dbBorder.normal.color : defaultBorder.normal.color,
            borderStyle: dbBorder.normal?.borderStyle !== '' ? dbBorder.normal.borderStyle : defaultBorder.normal.borderStyle,
            selectedPosition: dbBorder.normal?.selectedPosition !== '' ? dbBorder.normal.selectedPosition : defaultBorder.normal.selectedPosition,
            borderWidth: dbBorder.normal?.borderWidth !== '' ? dbBorder.normal.borderWidth : defaultBorder.normal.borderWidth,
            borderWidthUnit: dbBorder.normal?.borderWidthUnit ?? defaultBorder.normal.borderWidthUnit
        },
        hover: {
            color: dbBorder.hover?.color !== '' ? dbBorder.hover.color : defaultBorder.hover.color,
            borderStyle: dbBorder.hover?.borderStyle !== '' ? dbBorder.hover.borderStyle : defaultBorder.hover.borderStyle,
            selectedPosition: dbBorder.hover?.selectedPosition !== '' ? dbBorder.hover.selectedPosition : defaultBorder.hover.selectedPosition,
            borderWidth: dbBorder.hover?.borderWidth !== '' ? dbBorder.hover.borderWidth : defaultBorder.hover.borderWidth,
            borderWidthUnit: dbBorder.hover?.borderWidthUnit ?? defaultBorder.hover.borderWidthUnit
        }
    };
}

export function mergeBorderRadius(defaultBorderRadius, dbBorderRadius) {
    // Ensure dbBorderRadius is defined, fallback to empty object if not
    dbBorderRadius = dbBorderRadius || {};

    return {
        normal: {
            mobile: {
                style: (dbBorderRadius.normal?.mobile?.style?.length > 0) ? dbBorderRadius.normal.mobile.style : defaultBorderRadius.normal.mobile.style,
                topLeft: (dbBorderRadius.normal?.mobile?.topLeft) ? dbBorderRadius.normal.mobile.topLeft : defaultBorderRadius.normal.mobile.topLeft,
                topLeftUnit: dbBorderRadius.normal?.mobile?.topLeftUnit ?? defaultBorderRadius.normal.mobile.topLeftUnit,
                topRight: (dbBorderRadius.normal?.mobile?.topRight) ? dbBorderRadius.normal.mobile.topRight : defaultBorderRadius.normal.mobile.topRight,
                topRightUnit: dbBorderRadius.normal?.mobile?.topRightUnit ?? defaultBorderRadius.normal.mobile.topRightUnit,
                bottomLeft: (dbBorderRadius.normal?.mobile?.bottomLeft) ? dbBorderRadius.normal.mobile.bottomLeft : defaultBorderRadius.normal.mobile.bottomLeft,
                bottomLeftUnit: dbBorderRadius.normal?.mobile?.bottomLeftUnit ?? defaultBorderRadius.normal.mobile.bottomLeftUnit,
                bottomRight: (dbBorderRadius.normal?.mobile?.bottomRight) ? dbBorderRadius.normal.mobile.bottomRight : defaultBorderRadius.normal.mobile.bottomRight,
                bottomRightUnit: dbBorderRadius.normal?.mobile?.bottomRightUnit ?? defaultBorderRadius.normal.mobile.bottomRightUnit
            },
            tablet: {
                style: (dbBorderRadius.normal?.tablet?.style?.length > 0) ? dbBorderRadius.normal.tablet.style : defaultBorderRadius.normal.tablet.style,
                topLeft: (dbBorderRadius.normal?.tablet?.topLeft) ? dbBorderRadius.normal.tablet.topLeft : defaultBorderRadius.normal.tablet.topLeft,
                topLeftUnit: dbBorderRadius.normal?.tablet?.topLeftUnit ?? defaultBorderRadius.normal.tablet.topLeftUnit,
                topRight: (dbBorderRadius.normal?.tablet?.topRight) ? dbBorderRadius.normal.tablet.topRight : defaultBorderRadius.normal.tablet.topRight,
                topRightUnit: dbBorderRadius.normal?.tablet?.topRightUnit ?? defaultBorderRadius.normal.tablet.topRightUnit,
                bottomLeft: (dbBorderRadius.normal?.tablet?.bottomLeft) ? dbBorderRadius.normal.tablet.bottomLeft : defaultBorderRadius.normal.tablet.bottomLeft,
                bottomLeftUnit: dbBorderRadius.normal?.tablet?.bottomLeftUnit ?? defaultBorderRadius.normal.tablet.bottomLeftUnit,
                bottomRight: (dbBorderRadius.normal?.tablet?.bottomRight) ? dbBorderRadius.normal.tablet.bottomRight : defaultBorderRadius.normal.tablet.bottomRight,
                bottomRightUnit: dbBorderRadius.normal?.tablet?.bottomRightUnit ?? defaultBorderRadius.normal.tablet.bottomRightUnit
            },
            desktop: {
                style: (dbBorderRadius.normal?.desktop?.style?.length > 0) ? dbBorderRadius.normal.desktop.style : defaultBorderRadius.normal.desktop.style,
                topLeft: (dbBorderRadius.normal?.desktop?.topLeft) ? dbBorderRadius.normal.desktop.topLeft : defaultBorderRadius.normal.desktop.topLeft,
                topLeftUnit: dbBorderRadius.normal?.desktop?.topLeftUnit ?? defaultBorderRadius.normal.desktop.topLeftUnit,
                topRight: (dbBorderRadius.normal?.desktop?.topRight) ? dbBorderRadius.normal.desktop.topRight : defaultBorderRadius.normal.desktop.topRight,
                topRightUnit: dbBorderRadius.normal?.desktop?.topRightUnit ?? defaultBorderRadius.normal.desktop.topRightUnit,
                bottomLeft: (dbBorderRadius.normal?.desktop?.bottomLeft) ? dbBorderRadius.normal.desktop.bottomLeft : defaultBorderRadius.normal.desktop.bottomLeft,
                bottomLeftUnit: dbBorderRadius.normal?.desktop?.bottomLeftUnit ?? defaultBorderRadius.normal.desktop.bottomLeftUnit,
                bottomRight: (dbBorderRadius.normal?.desktop?.bottomRight) ? dbBorderRadius.normal.desktop.bottomRight : defaultBorderRadius.normal.desktop.bottomRight,
                bottomRightUnit: dbBorderRadius.normal?.desktop?.bottomRightUnit ?? defaultBorderRadius.normal.desktop.bottomRightUnit
            }
        },
        hover: {
            mobile: {
                style: (dbBorderRadius.hover?.mobile?.style?.length > 0) ? dbBorderRadius.hover.mobile.style : defaultBorderRadius.hover.mobile.style,
                topLeft: (dbBorderRadius.hover?.mobile?.topLeft) ? dbBorderRadius.hover.mobile.topLeft : defaultBorderRadius.hover.mobile.topLeft,
                topLeftUnit: dbBorderRadius.hover?.mobile?.topLeftUnit ?? defaultBorderRadius.hover.mobile.topLeftUnit,
                topRight: (dbBorderRadius.hover?.mobile?.topRight) ? dbBorderRadius.hover.mobile.topRight : defaultBorderRadius.hover.mobile.topRight,
                topRightUnit: dbBorderRadius.hover?.mobile?.topRightUnit ?? defaultBorderRadius.hover.mobile.topRightUnit,
                bottomLeft: (dbBorderRadius.hover?.mobile?.bottomLeft) ? dbBorderRadius.hover.mobile.bottomLeft : defaultBorderRadius.hover.mobile.bottomLeft,
                bottomLeftUnit: dbBorderRadius.hover?.mobile?.bottomLeftUnit ?? defaultBorderRadius.hover.mobile.bottomLeftUnit,
                bottomRight: (dbBorderRadius.hover?.mobile?.bottomRight) ? dbBorderRadius.hover.mobile.bottomRight : defaultBorderRadius.hover.mobile.bottomRight,
                bottomRightUnit: dbBorderRadius.hover?.mobile?.bottomRightUnit ?? defaultBorderRadius.hover.mobile.bottomRightUnit
            },
            tablet: {
                style: (dbBorderRadius.hover?.tablet?.style?.length > 0) ? dbBorderRadius.hover.tablet.style : defaultBorderRadius.hover.tablet.style,
                topLeft: (dbBorderRadius.hover?.tablet?.topLeft) ? dbBorderRadius.hover.tablet.topLeft : defaultBorderRadius.hover.tablet.topLeft,
                topLeftUnit: dbBorderRadius.hover?.tablet?.topLeftUnit ?? defaultBorderRadius.hover.tablet.topLeftUnit,
                topRight: (dbBorderRadius.hover?.tablet?.topRight) ? dbBorderRadius.hover.tablet.topRight : defaultBorderRadius.hover.tablet.topRight,
                topRightUnit: dbBorderRadius.hover?.tablet?.topRightUnit ?? defaultBorderRadius.hover.tablet.topRightUnit,
                bottomLeft: (dbBorderRadius.hover?.tablet?.bottomLeft) ? dbBorderRadius.hover.tablet.bottomLeft : defaultBorderRadius.hover.tablet.bottomLeft,
                bottomLeftUnit: dbBorderRadius.hover?.tablet?.bottomLeftUnit ?? defaultBorderRadius.hover.tablet.bottomLeftUnit,
                bottomRight: (dbBorderRadius.hover?.tablet?.bottomRight) ? dbBorderRadius.hover.tablet.bottomRight : defaultBorderRadius.hover.tablet.bottomRight,
                bottomRightUnit: dbBorderRadius.hover?.tablet?.bottomRightUnit ?? defaultBorderRadius.hover.tablet.bottomRightUnit
            },
            desktop: {
                style: (dbBorderRadius.hover?.desktop?.style?.length > 0) ? dbBorderRadius.hover.desktop.style : defaultBorderRadius.hover.desktop.style,
                topLeft: (dbBorderRadius.hover?.desktop?.topLeft) ? dbBorderRadius.hover.desktop.topLeft : defaultBorderRadius.hover.desktop.topLeft,
                topLeftUnit: dbBorderRadius.hover?.desktop?.topLeftUnit ?? defaultBorderRadius.hover.desktop.topLeftUnit,
                topRight: (dbBorderRadius.hover?.desktop?.topRight) ? dbBorderRadius.hover.desktop.topRight : defaultBorderRadius.hover.desktop.topRight,
                topRightUnit: dbBorderRadius.hover?.desktop?.topRightUnit ?? defaultBorderRadius.hover.desktop.topRightUnit,
                bottomLeft: (dbBorderRadius.hover?.desktop?.bottomLeft) ? dbBorderRadius.hover.desktop.bottomLeft : defaultBorderRadius.hover.desktop.bottomLeft,
                bottomLeftUnit: dbBorderRadius.hover?.desktop?.bottomLeftUnit ?? defaultBorderRadius.hover.desktop.bottomLeftUnit,
                bottomRight: (dbBorderRadius.hover?.desktop?.bottomRight) ? dbBorderRadius.hover.desktop.bottomRight : defaultBorderRadius.hover.desktop.bottomRight,
                bottomRightUnit: dbBorderRadius.hover?.desktop?.bottomRightUnit ?? defaultBorderRadius.hover.desktop.bottomRightUnit
            }
        }
    };
}

export function mergePaddings(defaultPaddings, dbPaddings) {
    // Ensure dbPaddings is defined and fallback to an empty object if it's not
    dbPaddings = dbPaddings || {};

    return {
        mobile: {
            top: dbPaddings.mobile?.top !== '' ? dbPaddings.mobile?.top ?? defaultPaddings.mobile.top : defaultPaddings.mobile.top,
            topUnit: dbPaddings.mobile?.topUnit ?? defaultPaddings.mobile.topUnit,
            bottom: dbPaddings.mobile?.bottom !== '' ? dbPaddings.mobile?.bottom ?? defaultPaddings.mobile.bottom : defaultPaddings.mobile.bottom,
            bottomUnit: dbPaddings.mobile?.bottomUnit ?? defaultPaddings.mobile.bottomUnit,
            left: dbPaddings.mobile?.left !== '' ? dbPaddings.mobile?.left ?? defaultPaddings.mobile.left : defaultPaddings.mobile.left,
            leftUnit: dbPaddings.mobile?.leftUnit ?? defaultPaddings.mobile.leftUnit,
            right: dbPaddings.mobile?.right !== '' ? dbPaddings.mobile?.right ?? defaultPaddings.mobile.right : defaultPaddings.mobile.right,
            rightUnit: dbPaddings.mobile?.rightUnit ?? defaultPaddings.mobile.rightUnit,
        },
        tablet: {
            top: dbPaddings.tablet?.top !== '' ? dbPaddings.tablet?.top ?? defaultPaddings.tablet.top : defaultPaddings.tablet.top,
            topUnit: dbPaddings.tablet?.topUnit ?? defaultPaddings.tablet.topUnit,
            bottom: dbPaddings.tablet?.bottom !== '' ? dbPaddings.tablet?.bottom ?? defaultPaddings.tablet.bottom : defaultPaddings.tablet.bottom,
            bottomUnit: dbPaddings.tablet?.bottomUnit ?? defaultPaddings.tablet.bottomUnit,
            left: dbPaddings.tablet?.left !== '' ? dbPaddings.tablet?.left ?? defaultPaddings.tablet.left : defaultPaddings.tablet.left,
            leftUnit: dbPaddings.tablet?.leftUnit ?? defaultPaddings.tablet.leftUnit,
            right: dbPaddings.tablet?.right !== '' ? dbPaddings.tablet?.right ?? defaultPaddings.tablet.right : defaultPaddings.tablet.right,
            rightUnit: dbPaddings.tablet?.rightUnit ?? defaultPaddings.tablet.rightUnit,
        },
        desktop: {
            top: dbPaddings.desktop?.top !== '' ? dbPaddings.desktop?.top ?? defaultPaddings.desktop.top : defaultPaddings.desktop.top,
            topUnit: dbPaddings.desktop?.topUnit ?? defaultPaddings.desktop.topUnit,
            bottom: dbPaddings.desktop?.bottom !== '' ? dbPaddings.desktop?.bottom ?? defaultPaddings.desktop.bottom : defaultPaddings.desktop.bottom,
            bottomUnit: dbPaddings.desktop?.bottomUnit ?? defaultPaddings.desktop.bottomUnit,
            left: dbPaddings.desktop?.left !== '' ? dbPaddings.desktop?.left ?? defaultPaddings.desktop.left : defaultPaddings.desktop.left,
            leftUnit: dbPaddings.desktop?.leftUnit ?? defaultPaddings.desktop.leftUnit,
            right: dbPaddings.desktop?.right !== '' ? dbPaddings.desktop?.right ?? defaultPaddings.desktop.right : defaultPaddings.desktop.right,
            rightUnit: dbPaddings.desktop?.rightUnit ?? defaultPaddings.desktop.rightUnit,
        }
    };
}

export function mergeMargins(defaultMargins, dbMargins) {
    // Ensure dbMargins is defined and fallback to an empty object if it's not
    dbMargins = dbMargins || {};

    return {
        mobile: {
            auto: dbMargins.mobile?.top === 'auto',
            top: dbMargins.mobile?.top !== '' ? dbMargins.mobile?.top ?? defaultMargins.mobile.top : defaultMargins.mobile.top,
            topUnit: dbMargins.mobile?.topUnit ?? defaultMargins.mobile.topUnit,
            bottom: dbMargins.mobile?.bottom !== '' ? dbMargins.mobile?.bottom ?? defaultMargins.mobile.bottom : defaultMargins.mobile.bottom,
            bottomUnit: dbMargins.mobile?.bottomUnit ?? defaultMargins.mobile.bottomUnit,
            left: dbMargins.mobile?.left !== '' ? dbMargins.mobile?.left ?? defaultMargins.mobile.left : defaultMargins.mobile.left,
            leftUnit: dbMargins.mobile?.leftUnit ?? defaultMargins.mobile.leftUnit,
            right: dbMargins.mobile?.right !== '' ? dbMargins.mobile?.right ?? defaultMargins.mobile.right : defaultMargins.mobile.right,
            rightUnit: dbMargins.mobile?.rightUnit ?? defaultMargins.mobile.rightUnit,
        },
        tablet: {
            auto: dbMargins.tablet?.top === 'auto',
            top: dbMargins.tablet?.top !== '' ? dbMargins.tablet?.top ?? defaultMargins.tablet.top : defaultMargins.tablet.top,
            topUnit: dbMargins.tablet?.topUnit ?? defaultMargins.tablet.topUnit,
            bottom: dbMargins.tablet?.bottom !== '' ? dbMargins.tablet?.bottom ?? defaultMargins.tablet.bottom : defaultMargins.tablet.bottom,
            bottomUnit: dbMargins.tablet?.bottomUnit ?? defaultMargins.tablet.bottomUnit,
            left: dbMargins.tablet?.left !== '' ? dbMargins.tablet?.left ?? defaultMargins.tablet.left : defaultMargins.tablet.left,
            leftUnit: dbMargins.tablet?.leftUnit ?? defaultMargins.tablet.leftUnit,
            right: dbMargins.tablet?.right !== '' ? dbMargins.tablet?.right ?? defaultMargins.tablet.right : defaultMargins.tablet.right,
            rightUnit: dbMargins.tablet?.rightUnit ?? defaultMargins.tablet.rightUnit,
        },
        desktop: {
            auto: dbMargins.desktop?.top === 'auto',
            top: dbMargins.desktop?.top !== '' ? dbMargins.desktop?.top ?? defaultMargins.desktop.top : defaultMargins.desktop.top,
            topUnit: dbMargins.desktop?.topUnit ?? defaultMargins.desktop.topUnit,
            bottom: dbMargins.desktop?.bottom !== '' ? dbMargins.desktop?.bottom ?? defaultMargins.desktop.bottom : defaultMargins.desktop.bottom,
            bottomUnit: dbMargins.desktop?.bottomUnit ?? defaultMargins.desktop.bottomUnit,
            left: dbMargins.desktop?.left !== '' ? dbMargins.desktop?.left ?? defaultMargins.desktop.left : defaultMargins.desktop.left,
            leftUnit: dbMargins.desktop?.leftUnit ?? defaultMargins.desktop.leftUnit,
            right: dbMargins.desktop?.right !== '' ? dbMargins.desktop?.right ?? defaultMargins.desktop.right : defaultMargins.desktop.right,
            rightUnit: dbMargins.desktop?.rightUnit ?? defaultMargins.desktop.rightUnit,
        }
    };
}

export function mergeBackgroundStyles(defaultBackgroundStyles, dbBackgroundStyles) {
    dbBackgroundStyles = dbBackgroundStyles || {};

    return {
        normal: {
            backgroundType: dbBackgroundStyles.normal?.backgroundType ?? defaultBackgroundStyles.normal.backgroundType,
            gradientFrom: dbBackgroundStyles.normal?.gradientFrom ?? defaultBackgroundStyles.normal.gradientFrom,
            gradientTo: dbBackgroundStyles.normal?.gradientTo ?? defaultBackgroundStyles.normal.gradientTo,
            gradientType: dbBackgroundStyles.normal?.gradientType ?? defaultBackgroundStyles.normal.gradientType,
            startPosition: dbBackgroundStyles.normal?.startPosition ?? defaultBackgroundStyles.normal.startPosition,
            endPosition: dbBackgroundStyles.normal?.endPosition ?? defaultBackgroundStyles.normal.endPosition,
            gradientDirection: dbBackgroundStyles.normal?.gradientDirection ?? defaultBackgroundStyles.normal.gradientDirection,
            radialShape: dbBackgroundStyles.normal?.radialShape ?? defaultBackgroundStyles.normal.radialShape,
            radialDirection: dbBackgroundStyles.normal?.radialDirection ?? defaultBackgroundStyles.normal.radialDirection,
            color: dbBackgroundStyles.normal?.color ?? defaultBackgroundStyles.normal.color,
            bgSize: dbBackgroundStyles.normal?.bgSize ?? defaultBackgroundStyles.normal.bgSize,
            bgPosition: dbBackgroundStyles.normal?.bgPosition ?? defaultBackgroundStyles.normal.bgPosition,
            bgRepeat: dbBackgroundStyles.normal?.bgRepeat ?? defaultBackgroundStyles.normal.bgRepeat,
            bgAttachment: dbBackgroundStyles.normal?.bgAttachment ?? defaultBackgroundStyles.normal.bgAttachment,
            overlayColor: dbBackgroundStyles.normal?.overlayColor ?? defaultBackgroundStyles.normal.overlayColor,
            bgImage: dbBackgroundStyles.normal?.bgImage ?? defaultBackgroundStyles.normal.bgImage,
            bgOpacity: dbBackgroundStyles.normal?.bgOpacity ?? defaultBackgroundStyles.normal.bgOpacity,
        },
        hover: {
            backgroundType: dbBackgroundStyles.hover?.backgroundType ?? defaultBackgroundStyles.hover.backgroundType,
            gradientFrom: dbBackgroundStyles.hover?.gradientFrom ?? defaultBackgroundStyles.hover.gradientFrom,
            gradientTo: dbBackgroundStyles.hover?.gradientTo ?? defaultBackgroundStyles.hover.gradientTo,
            gradientType: dbBackgroundStyles.hover?.gradientType ?? defaultBackgroundStyles.hover.gradientType,
            startPosition: dbBackgroundStyles.hover?.startPosition ?? defaultBackgroundStyles.hover.startPosition,
            endPosition: dbBackgroundStyles.hover?.endPosition ?? defaultBackgroundStyles.hover.endPosition,
            gradientDirection: dbBackgroundStyles.hover?.gradientDirection ?? defaultBackgroundStyles.hover.gradientDirection,
            radialShape: dbBackgroundStyles.hover?.radialShape ?? defaultBackgroundStyles.hover.radialShape,
            radialDirection: dbBackgroundStyles.hover?.radialDirection ?? defaultBackgroundStyles.hover.radialDirection,
            color: dbBackgroundStyles.hover?.color ?? defaultBackgroundStyles.hover.color,
            bgSize: dbBackgroundStyles.hover?.bgSize ?? defaultBackgroundStyles.hover.bgSize,
            bgPosition: dbBackgroundStyles.hover?.bgPosition ?? defaultBackgroundStyles.hover.bgPosition,
            bgRepeat: dbBackgroundStyles.hover?.bgRepeat ?? defaultBackgroundStyles.hover.bgRepeat,
            bgAttachment: dbBackgroundStyles.hover?.bgAttachment ?? defaultBackgroundStyles.hover.bgAttachment,
            overlayColor: dbBackgroundStyles.hover?.overlayColor ?? defaultBackgroundStyles.hover.overlayColor,
            bgImage: dbBackgroundStyles.hover?.bgImage ?? defaultBackgroundStyles.hover.bgImage,
            bgOpacity: dbBackgroundStyles.hover?.bgOpacity ?? defaultBackgroundStyles.hover.bgOpacity,
        }
    };
}

export function mergeLinePosition(defaultLinePosition, dbLinePosition = {}) {
    return {
        normal: {
            position: dbLinePosition?.normal?.position && dbLinePosition.normal.position !== 'none'
                ? dbLinePosition.normal.position
                : defaultLinePosition.normal.position,
            color: dbLinePosition?.normal?.color ?? defaultLinePosition.normal.color,
            style: dbLinePosition?.normal?.style ?? defaultLinePosition.normal.style,
            thickness: dbLinePosition?.normal?.thickness ?? defaultLinePosition.normal.thickness,
        },
        hover: {
            position: dbLinePosition?.hover?.position && dbLinePosition.hover.position !== 'none'
                ? dbLinePosition.hover.position
                : defaultLinePosition.hover.position,
            color: dbLinePosition?.hover?.color ?? defaultLinePosition.hover.color,
            style: dbLinePosition?.hover?.style ?? defaultLinePosition.hover.style,
            thickness: dbLinePosition?.hover?.thickness ?? defaultLinePosition.hover.thickness,
        }
    };
}

export function mergeColor(defaultColor, dbColor = {}) {
    return {
        normal: dbColor?.normal ?? defaultColor.normal,
        hover: dbColor?.hover ?? defaultColor.hover
    };
}

export function mergeTextTransform(defaultTextTransform, dbTextTransform = {}) {
    return {
        desktop: dbTextTransform?.desktop ?? defaultTextTransform.desktop,
        tablet: dbTextTransform?.tablet ?? defaultTextTransform.tablet,
        mobile: dbTextTransform?.mobile ?? defaultTextTransform.mobile
    };
}

export function mergeLetterSpacing(defaultLetterSpacing, dbLetterSpacing = {}) {
    return {
        desktop: dbLetterSpacing?.desktop ?? defaultLetterSpacing.desktop,
        desktopUnit: dbLetterSpacing?.desktopUnit ?? defaultLetterSpacing.desktopUnit,
        tablet: dbLetterSpacing?.tablet ?? defaultLetterSpacing.tablet,
        tabletUnit: dbLetterSpacing?.tabletUnit ?? defaultLetterSpacing.tabletUnit,
        mobile: dbLetterSpacing?.mobile ?? defaultLetterSpacing.mobile,
        mobileUnit: dbLetterSpacing?.mobileUnit ?? defaultLetterSpacing.mobileUnit
    };
}
export function mergeLineHeight(defaultLineHeight, dbLineHeight = {}) {
    return {
        desktop: dbLineHeight?.desktop ?? defaultLineHeight.desktop,
        desktopUnit: dbLineHeight?.desktopUnit ?? defaultLineHeight.desktopUnit,
        tablet: dbLineHeight?.tablet ?? defaultLineHeight.tablet,
        tabletUnit: dbLineHeight?.tabletUnit ?? defaultLineHeight.tabletUnit,
        mobile: dbLineHeight?.mobile ?? defaultLineHeight.mobile,
        mobileUnit: dbLineHeight?.mobileUnit ?? defaultLineHeight.mobileUnit
    };
}
export function mergeAlignment(defaultAlignment, dbAlignment = {}) {
    return {
        desktop: dbAlignment?.desktop ?? defaultAlignment.desktop,
        tablet: dbAlignment?.tablet ?? defaultAlignment.tablet,
        mobile: dbAlignment?.mobile ?? defaultAlignment.mobile
    };
}

export function createMargins() {
    return {
        mobile: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        },
        tablet: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        },
        desktop: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        },
    };
}
export function createLinePosition() {
    return {
        normal: {
            position: 'none',
            color: '',
            style: 'solid',
            thickness: 5,
        },
        hover: {
            position: 'none',
            color: '',
            style: 'solid',
            thickness: 5,
        }
    };
}
export function createTextTransform() {
    return {
        desktop: 'normal',
        tablet: 'normal',
        mobile: 'normal'
    };
}
export function createAlignment() {
    return {
        desktop: '',
        tablet: '',
        mobile: ''
    };
}
export function createFontSize() {
    return {
        desktop: '',
        tablet: '',
        mobile: ''
    };
}

export function createFontTypography() {
    return {
        weight: '',
        family: '',
    };
}

export function createLetterSpacing() {
    return {
        desktop: '',
        desktopUnit: 'px',
        tablet: '',
        tabletUnit: 'px',
        mobile: '',
        mobileUnit: 'px'
    };
}

export function createLineHeight() {
    return {
        desktop: '',
        desktopUnit: 'px',
        tablet: '',
        tabletUnit: 'px',
        mobile: '',
        mobileUnit: 'px'
    };
}

export function createPadding() {
    return {
        mobile: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        },
        tablet: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        },
        desktop: {
            top: '',
            topUnit: 'px',
            bottom: '',
            bottomUnit: 'px',
            left: '',
            leftUnit: 'px',
            right: '',
            rightUnit: 'px',
        }
    };
}

export function createFontAwesomeIcons() {
    return ["fab fa-facebook-f", "fab fa-instagram", "fab fa-youtube", "fab fa-linkedin", "fas fa-map-marker-alt", "fa-solid fa-circle-question",
        "fas fa-envelope", "fas fa-at", "fas fa-th", "fas fa-credit-card", "fas fa-list-ul", "fas fa-hdd", "fas fa-database",
        "fa-solid fa-star", "fa-solid fa-heart", "fa-solid fa-user", "fa-solid fa-cog", "fa-solid fa-envelope",
        "fa-solid fa-check", "fa-solid fa-times", "fa-solid fa-plus", "fa-solid fa-home", "fa-solid fa-camera",
        "fa-solid fa-car", "fa-solid fa-truck", "fa-solid fa-plane", "fa-solid fa-tree", "fa-solid fa-phone",
        "fa-solid fa-moon", "fa-solid fa-sun", "fa-solid fa-smile", "fa-solid fa-circle", "fa-solid fa-square",
        "fa-solid fa-arrow-up", "fa-solid fa-arrow-down", "fa-solid fa-arrow-left", "fa-solid fa-arrow-right",
        "fa-solid fa-shopping-cart", "fa-solid fa-bell", "fa-solid fa-search", "fa-solid fa-map", "fa-solid fa-key",
        "fa-solid fa-lock", "fa-solid fa-unlock", "fa-solid fa-book", "fa-solid fa-lightbulb", "fa-solid fa-music",
        "fa-solid fa-play", "fa-solid fa-pause", "fa-solid fa-stop", "fa-solid fa-folder", "fa-solid fa-cloud",
        "fa-solid fa-wifi", "fa-solid fa-tv", "fa-solid fa-laptop", "fa-solid fa-desktop", "fa-solid fa-globe",
        "fa-solid fa-calendar", "fa-solid fa-clock", "fa-solid fa-graduation-cap", "fa-solid fa-money-bill",
        "fa-solid fa-credit-card", "fa-solid fa-chart-line", "fa-solid fa-file", "fa-solid fa-file-alt",
        "fa-solid fa-rocket", "fa-solid fa-bug", "fa-solid fa-code", "fa-solid fa-database", "fa-solid fa-bomb",
        "fa-solid fa-gem", "fa-solid fa-glass-martini", "fa-solid fa-gift", "fa-solid fa-headphones", "fa-solid fa-leaf",
        "fa-solid fa-life-ring", "fa-solid fa-microphone", "fa-solid fa-paper-plane",
        "fa-solid fa-paragraph", "fa-solid fa-print", "fa-solid fa-road", "fa-solid fa-shield-alt", "fa-solid fa-trash",
        "fa-solid fa-tools", "fa-solid fa-user-circle", "fa-solid fa-user-shield", "fa-solid fa-user-secret",
        "fa-solid fa-volume-up", "fa-solid fa-volume-mute", "fa-solid fa-wallet", "fa-solid fa-hands-helping",
        "fa-solid fa-laugh", "fa-solid fa-angry", "fa-solid fa-frown", "fa-solid fa-skull", "fa-solid fa-ghost",
        "fa-solid fa-chevron-down",  "fa-solid fa-download"
    ];
}

export function createColors() {
    return {
        normal: '',
        hover: ''
    };
}

export function createBackgroundStyles() {
    return {
        normal: {
            backgroundType: 'color',
            gradientFrom: '#ff0000',
            gradientTo: '#0000ff',
            gradientType: 'linear',
            startPosition: 0,
            endPosition: 100,
            gradientDirection: 90,
            radialShape: 'circle',
            radialDirection: 'center',
            color: '',
            bgSize: '',
            bgPosition: '',
            bgRepeat: '',
            bgAttachment: '',
            overlayColor: '',
            bgImage: '',
            bgOpacity: ''
        },
        hover: {
            backgroundType: 'color',
            gradientFrom: '#ff0000',
            gradientTo: '#0000ff',
            gradientType: 'linear',
            startPosition: 0,
            endPosition: 100,
            gradientDirection: 90,
            radialShape: 'circle',
            radialDirection: 'center',
            color: '',
            bgSize: '',
            bgPosition: '',
            bgRepeat: '',
            bgAttachment: '',
            overlayColor: '',
            bgImage: '',
            bgOpacity: ''
        }
    };
}
